import { render, staticRenderFns } from "./DosageInfo.vue?vue&type=template&id=0253edac&scoped=true"
import script from "./DosageInfo.vue?vue&type=script&lang=js"
export * from "./DosageInfo.vue?vue&type=script&lang=js"
import style0 from "./DosageInfo.vue?vue&type=style&index=0&id=0253edac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253edac",
  null
  
)

export default component.exports